import { render, staticRenderFns } from "./b-hover-options-dropdown.vue?vue&type=template&id=115bc820&scoped=true"
import script from "./b-hover-options-dropdown.vue?vue&type=script&lang=js"
export * from "./b-hover-options-dropdown.vue?vue&type=script&lang=js"
import style0 from "./b-hover-options-dropdown.vue?vue&type=style&index=0&id=115bc820&prod&lang=scss&scoped=true"
import style1 from "./b-hover-options-dropdown.vue?vue&type=style&index=1&id=115bc820&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115bc820",
  null
  
)

export default component.exports